export const NewYork = {
    name: "New York",
    image: "/New_York.avif",
    overview: {
        title: "Why Bangladeshi Students Choose New York for Higher Studies?",
        descriptions: [
            "Bangladeshi students choose New York for its world-renowned universities, diverse culture, and unparalleled career opportunities. The state offers access to top-ranked institutions and a vibrant academic environment.",
            "New York's status as a global financial and cultural hub, combined with excellent universities and extensive networking opportunities, makes it an ideal destination for ambitious international students."
        ],
    },
    highlights: [
        {
            icon: "fas fa-city",
            title: "Student-friendly cities",
            description: "New York City ranks among the top student cities globally, with world-class universities and endless opportunities."
        },
        {
            icon: "fas fa-briefcase",
            title: "Post-study work rights",
            description: "New York offers OPT (Optional Practical Training) for up to 3 years for STEM graduates and 1 year for non-STEM graduates."
        },
        {
            icon: "fas fa-graduation-cap",
            title: "Top universities",
            description: "New York is home to prestigious institutions like Columbia University, NYU, and Cornell University, all ranking in the top 100 globally."
        },
        {
            icon: "fas fa-users",
            title: "Global hub",
            description: "New York's diverse population and global connections provide excellent networking and career opportunities."
        }
    ],
    keyFacts: [
        { factNumber: "200+", factLabel: "Colleges and universities" },
        { factNumber: "1,20,000", factLabel: "International Students in New York in 2024" },
        { factNumber: "20 Hours", factLabel: "Per week Part-time work permit" },
        { factNumber: "3 Years", factLabel: "Post-study work permit (STEM)" }
    ],
    stats: {
        capital: "Albany",
        poplulation: "19.5 million",
        economicGrowthRate: "2.3%",
        currency: "US Dollar (USD)",
        language: "English",
        weather: [
            "New York City: 20°C - 29°C",
            "Buffalo: 18°C - 26°C",
            "Rochester: 19°C - 27°C",
            "Syracuse: 18°C - 26°C"
        ]
    },
    requirements: [
        "Academic transcripts",
        "Standardized test scores (SAT, ACT, GRE, GMAT)",
        "English proficiency test scores (TOEFL, IELTS)",
        "Statement of Purpose",
        "Letter of Recommendation",
        "Valid passport copy",
        "Proof of finances (Bank statements, I-20 form)",
        "Health insurance"
    ],
    intake: {
        title: "New York universities offer three main intakes:",
        intakes: [
            {
                name: "Fall Intake",
                month: "Starts in August/September"
            },
            {
                name: "Spring Intake",
                month: "Starts in January/February"
            },
            {
                name: "Summer Intake",
                month: "Starts in May/June (Limited programs)"
            }
        ]
    },
    programs: [
        {
            name: "Associate Degree",
            duration: "2 years"
        },
        {
            name: "Bachelor's Degree",
            duration: "4 years"
        },
        {
            name: "Master's Degree",
            duration: "1-2 years"
        },
        {
            name: "PhD",
            duration: "4-6 years"
        },
        {
            name: "Professional Degree",
            duration: "3-4 years"
        }
    ],
    popularPrograms: {
        title: "New York offers world-class education across all fields. Popular programs for international students include:",
        programs: [
            "Business Administration",
            "Computer Science",
            "Engineering",
            "Medicine",
            "Law",
            "Finance",
            "Data Science",
            "International Relations",
            "Arts and Design"
        ]
    },
    costs: [
        {
            program: "Community College",
            local: "USD 5,000 - 8,000",
            bdt: "5,50,000 – 8,80,000 BDT"
        },
        {
            program: "State University",
            local: "USD 15,000 - 25,000",
            bdt: "16,50,000 – 27,50,000 BDT"
        },
        {
            program: "Private University",
            local: "USD 30,000 - 60,000",
            bdt: "33,00,000 – 66,00,000 BDT"
        },
        {
            program: "Graduate Programs",
            local: "USD 25,000 - 80,000",
            bdt: "27,50,000 – 88,00,000 BDT"
        }
    ],
    topCities: {
        title: "New York offers excellent education in several vibrant cities with diverse opportunities. Key student cities include:",
        cities: [
            {
                name: "New York City",
                description: "Global hub with top universities and endless opportunities"
            },
            {
                name: "Buffalo",
                description: "Affordable city with excellent university and research facilities"
            },
            {
                name: "Rochester",
                description: "Tech city with strong engineering and medical programs"
            },
            {
                name: "Syracuse",
                description: "University city with focus on business and communications"
            },
            {
                name: "Albany",
                description: "Capital city with government and policy programs"
            },
            {
                name: "Ithaca",
                description: "College town with prestigious Cornell University"
            }
        ]
    },
    workOptions: {
        partTimeWork: "International students can work up to 20 hours per week on-campus during study periods and full-time during breaks. Off-campus work requires authorization. Students typically earn USD 12-20 per hour.",
        postStudyWork: "The Optional Practical Training (OPT) program allows graduates to work in the US for up to 1 year (non-STEM) or 3 years (STEM) after graduation. This provides excellent opportunities to gain work experience in New York's diverse economy."
    },
    faqs: [
        {
            question: "How do I apply for a student visa in New York?",
            answer: "To apply for a student visa, you need an I-20 form from a US institution, proof of English proficiency, financial capacity, and a completed DS-160 form. The application is processed through the US Embassy or Consulate."
        },
        {
            question: "What are the English language requirements for studying in New York?",
            answer: "Most New York institutions require TOEFL (80-100), IELTS (6.5-7.0), or Duolingo (105-120) scores. Some programs may require higher scores, especially for competitive programs."
        },
        {
            question: "Can I work while studying in New York?",
            answer: "Yes, international students can work up to 20 hours per week on-campus during study periods and full-time during breaks. Off-campus work requires authorization. The OPT program allows graduates to work after completing their studies."
        },
        {
            question: "Are scholarships available for international students in New York?",
            answer: "Yes, there are various scholarships offered by universities, government, and external organizations. These include merit-based, need-based, and program-specific scholarships."
        },
        {
            question: "How much does it cost to study in New York from Bangladesh?",
            answer: "Studying in New York from Bangladesh costs around USD 15,000-60,000 for tuition, USD 1,200-2,000 per month for living expenses, and USD 1,000-2,000 for health insurance annually. Total annual cost ranges from USD 30,000-85,000."
        },
        {
            question: "What GPA is required to study in New York from Bangladesh?",
            answer: "To study in New York from Bangladesh, the required GPA typically ranges from <strong>3.0 to 3.5</strong> on a 4.0 scale for undergraduate programs and <strong>3.2 to 3.7</strong> for postgraduate programs, depending on the university and program competitiveness."
        }
    ]
}
